<template>
  <el-container>
    <el-header>
      <el-row>
        <el-alert
          title="Seccion para guardar y visualizar los organgramas de la empresa"
          type="info"
          effect="dark"
          show-icon
        >
        </el-alert>
      </el-row>
    </el-header>
    <vue-scroll class="page-dashboard">
      <el-main>
        <el-row>
          <el-col :span="24" :offset="0">
            <CustomersFilesUploader
              UploadHeader="Organigramas"
              :DocumentType="6"
              :CompanyCode="this.currentCompany"
              :WatchImage="true"
            />
          </el-col>
        </el-row>
      </el-main>
    </vue-scroll>
  </el-container>
</template>

<script>
import CustomersFilesUploader from "@/components/Company/OurCompanyFilesUploader.vue";

export default {
  name: "OurCompanyOrganizationalCharts",

  components: {
    CustomersFilesUploader
  }
};
</script>

<style scoped></style>
